import React from 'react';
import { Icon } from '../../atoms/icon';
import * as styles from './icontext.module.sass';
import { IconColor } from '../../atoms/icon/enum/color';
import classNames from 'classnames';
import { Size } from '../../enums/size';

export const IconText = (props: any) => {
  const {
    icon_name,
    icon_background,
    iconWrapperClassName,
    className,
    title,
    icon_color = IconColor.PRIMARY,
    icon_size = Size.BIG,
    link=false,
    href,
    color,
    onClick,
    size,
    linkClassName
  } = props;

  const classProps: string = classNames({ [styles.icon_layout]: icon_background }, className);

  return (
    <div className={classNames(styles.icon_wrapper, iconWrapperClassName)}>
      <Icon color={icon_color} size={icon_size} className={icon_name} icon={classProps} />
      {
        link ?
          <a
            href={href ? href : `mailto: ${title}`}
            className={
              classNames(linkClassName,
                styles[size],
                styles[color])}
          >
            {title}</a>
          :
          <p
            className={
              classNames(className,
                styles[size],
                styles[color],
                styles.icn_text)}
            onClick={onClick}
          >{title}</p>
      }
    </div>
  );
};